module.exports = "/images/c5ba6d4fb970f1a8604b0a999ff224fc.svg";